import { Link } from "react-router-dom";
import { Facebook, Instagram, Linkedin, Twitter, Mail, Phone } from "lucide-react";

export function Footer() {
  return (
    <footer className="bg-slate-900 text-white">
      {/* Main Footer */}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-2 md:grid-cols-4 gap-8">
          {/* Chi Siamo */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Chi Siamo
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/contact" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Contatti
                </Link>
              </li>
              <li>
                <Link to="/how-it-works" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Come funziona
                </Link>
              </li>
              <li>
                <Link to="/guide-lavoro" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Guide e Risorse
                </Link>
              </li>
            </ul>
          </div>

          {/* Legale */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Legale
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/impressum" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Impressum
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Termini e Condizioni
                </Link>
              </li>
            </ul>
          </div>

          {/* Supporto */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Supporto
            </h3>
            <ul className="space-y-3">
              <li>
                <Link to="/help" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Aiuto / FAQ
                </Link>
              </li>
              <li>
                <Link to="/report" className="text-slate-400 hover:text-white text-sm transition-colors">
                  Segnala un abuso
                </Link>
              </li>
              <li>
                <a href="mailto:info@lavoroticino.ch" className="text-slate-400 hover:text-white text-sm transition-colors flex items-center gap-2">
                  <Mail className="w-4 h-4" />
                  Email
                </a>
              </li>
              <li>
                <a href="tel:+41786141854" className="text-slate-400 hover:text-white text-sm transition-colors flex items-center gap-2">
                  <Phone className="w-4 h-4" />
                  +41 78 614 18 54
                </a>
              </li>
            </ul>
          </div>

          {/* Social */}
          <div>
            <h3 className="text-sm font-bold text-white uppercase tracking-wider mb-4">
              Seguici
            </h3>
            <div className="flex gap-3">
              <a 
                href="https://www.facebook.com/share/17ZELSVJs7/" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-[#1877F2] rounded-lg flex items-center justify-center transition-colors"
                aria-label="Facebook"
              >
                <Facebook className="w-5 h-5" />
              </a>
              <a 
                href="https://www.instagram.com/lavoroticino.ch?igsh=bXNrbGpmemdjbzAy" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-[#E4405F] rounded-lg flex items-center justify-center transition-colors"
                aria-label="Instagram"
              >
                <Instagram className="w-5 h-5" />
              </a>
              <a 
                href="https://linkedin.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-[#0A66C2] rounded-lg flex items-center justify-center transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a 
                href="https://twitter.com" 
                target="_blank" 
                rel="noopener noreferrer"
                className="w-10 h-10 bg-slate-800 hover:bg-[#1DA1F2] rounded-lg flex items-center justify-center transition-colors"
                aria-label="Twitter"
              >
                <Twitter className="w-5 h-5" />
              </a>
            </div>
            
            {/* Newsletter mini */}
            <div className="mt-6">
              <p className="text-sm text-slate-400 mb-2">Resta aggiornato</p>
              <Link to="/register" className="text-sm text-[#DA291C] hover:text-white font-medium transition-colors">
                Registrati →
              </Link>
            </div>
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="border-t border-slate-800">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            {/* Copyright */}
            <div className="text-center md:text-left">
              <p className="text-sm text-slate-500">
                © 2026 <span className="text-white font-semibold">LavoroTicino.ch</span> — Sede in Ticino
              </p>
            </div>

            {/* Quick links */}
            <div className="flex flex-wrap justify-center gap-4 text-xs text-slate-500">
              <Link to="/jobs" className="hover:text-white transition-colors">Annunci lavoro</Link>
              <span>•</span>
              <Link to="/services" className="hover:text-white transition-colors">Servizi</Link>
              <span>•</span>
              <Link to="/candidates" className="hover:text-white transition-colors">Candidati</Link>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default Footer;
